import styled from 'styled-components';

import { BRAND_SWITCH } from '../theme/tokens';

/**
 * Positioning context for the brand switch. `position: relative` (not
 * transform/filter) so it doesn't establish a transform containing-block that
 * would re-anchor `PageShell`'s absolute header scrim. It fills the same content
 * column as before, so the scrim's geometry is unchanged.
 */
export const BrandFadeHost = styled.div`
  position: relative;
  height: 100%;
`;

/**
 * The live page. Fades to 0 over `FADE_OUT_MS` when hidden (while the data swaps
 * under cover) and back to 1 over `FADE_IN_MS` when the new brand comes in.
 * Opacity only — no transform/will-change (see host note).
 */
export const BrandFadeContent = styled.div<{ $hidden: boolean }>`
  height: 100%;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  transition: opacity ${({ $hidden }) => ($hidden ? BRAND_SWITCH.FADE_OUT_MS : BRAND_SWITCH.FADE_IN_MS)}ms
    ${BRAND_SWITCH.EASE};
`;

export default BrandFadeHost;
